<template>
  <div class="flex flex-col bg-white rounded-sm text-gray mx-2 my-3 p-2">
    <div class="px-4 mb-2">
      <span class="title">Default registrar</span>
    </div>
    <div class="mb-4 border-b border-gray-200">
      <nav class="flex space-x-6 px-4" aria-label="Tabs">
        <div :class="[currentRoute === 'verify' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('verify')">
        Verify registrar
        </div>
      </nav>
    </div>
    <div>
      <VerifyRegistrar v-if="currentRoute === 'verify'" ref="verifyRef" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import VerifyRegistrar from "./tabs/VerifyRegistrar.vue";

type TabRef = { refresh?: () => void } | null;

const currentRoute = ref("verify");
const verifyRef = ref<TabRef>(null);

const select = (route: string) => {
  currentRoute.value = route;
  nextTick(() => {
    if (route === "verify") verifyRef.value?.refresh?.();
  });
};

onMounted(() => {
  nextTick(() => verifyRef.value?.refresh?.());
});
</script>
